'use strict';

bbw.directive.bbwCountdown = ['$timeout', 'bbw.ServerTimeSvc', function($timeout, serverTime) {

    function zeroPad(value) {
        value = '' + value;
        while (value.length < 2) {
            value = "0" + value;
        }
        return value;
    }

    function formatTimeDuration(duration) {
        return [duration.hours(), zeroPad(duration.minutes()), zeroPad(duration.seconds())].join(':');
    }

    return {
        restrict: 'A',
        scope: {
            'bbwCountdown': '=',
            'countdownLabel': '@',
            'countdownHours': '=',
            'absLabel': '@',
            'absLabelHideDate': '=',
            'reachLabel': '@',
            'resolution': '@'
        },
        templateUrl: bbw.templateUrl('countdown.html'),
        link: function(scope, element) {
            var timeout;
            var countdown = scope.countdown = {};
            var update = function() {
                timeout = undefined;
                var now = serverTime.getTimestamp();
                var countdownTo = parseInt(scope.bbwCountdown);
                var diffms = 1000 * (countdownTo - now);
                if (diffms > 0) {
                    var diff = moment.duration(diffms);
                    var isAbsLabel = false;
                    if (scope.countdownHours) {
                        isAbsLabel = diff.years() == 0 && diff.months() == 0 && diff.days() == 0
                            && (diff.hours() >= scope.countdownHours);
                    } else {
                        isAbsLabel = diff.years() == 0 && diff.months() > 0;
                    }
                    if (isAbsLabel) {
                        countdown.enabled = false;
                        scope.label = scope.absLabel;
                    } else {
                        countdown.enabled = true;
                        countdown.days = diff.days();
                        countdown.time = formatTimeDuration(diff);
                        scope.label = scope.countdownLabel;
                        if (countdown.days <= 1) {
                            tick();
                        }
                    }
                } else {
                    countdown.enabled = false;
                    scope.reached = true;
                    scope.label = scope.reachLabel;
                }
            };

            var tick = function() {
                timeout = $timeout(update, scope.resolution || 250);
            };
            var stopTicking = function() {
                if (timeout) {
                    $timeout.cancel(timeout);
                    timeout = undefined;
                }
            };

            scope.$on('$destroy', stopTicking);
            element.on('$destroy', stopTicking);

            update();
        }
    };
}];
